// Small DOM helpers. GPL-3.0-or-later.
export const $ = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T;
export const $in = <T extends HTMLElement = HTMLElement>(root: ParentNode, sel: string) => root.querySelector(sel) as T;

/** Escape text for HTML. Every user-supplied string (names, file names) goes through it. */
export const esc = (s: unknown) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]!));

/** innerHTML only when the markup differs: a panel redrawn every frame must not re-mount (and re-animate) itself. */
const lastHTML = new WeakMap<Element, string>();
export function setHTML(el: Element, html: string) { if (lastHTML.get(el) === html) return; lastHTML.set(el, html); el.innerHTML = html; }

/** Is the user typing in a field (so single-key shortcuts must not fire)? */
export const isTyping = (t: EventTarget | null) => {
  const el = t as HTMLInputElement | null, tag = el?.tagName;
  return tag === "TEXTAREA" || tag === "SELECT" || (tag === "INPUT" && !["checkbox", "radio", "range", "button", "file"].includes(el!.type));
};

/** Save text or a blob as a file. */
export function download(name: string, data: string | Blob, type = "application/octet-stream") {
  const blob = typeof data === "string" ? new Blob([data], { type }) : data;
  const a = document.createElement("a"); a.href = URL.createObjectURL(blob); a.download = name;
  document.body.appendChild(a); a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
}

export const num = (el: HTMLInputElement | HTMLSelectElement, lo: number, hi: number, def: number) => {
  const v = Number(String(el.value).replace(",", "."));
  return Number.isFinite(v) ? Math.max(lo, Math.min(hi, v)) : def;
};
